/**
 * Demo Data Badge
 * Visual indicator that displayed data is illustrative only
 */

import { Badge } from '@/components/ui/badge';
import { FlaskConical, Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface DemoDataBadgeProps {
  variant?: 'inline' | 'banner';
  className?: string;
}

export function DemoDataBadge({ variant = 'inline', className }: DemoDataBadgeProps) {
  if (variant === 'banner') {
    return (
      <div className={cn(
        "flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg",
        "bg-amber-500/10 border border-amber-500/30 text-amber-600 dark:text-amber-400",
        className
      )}>
        <FlaskConical className="w-4 h-4" />
        <span className="text-xs font-medium">
          Demo Data — Illustrative Only
        </span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="w-3 h-3 cursor-help" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p className="text-xs">
                This panel displays simulated data for demonstration purposes. 
                In production, real historical data would be displayed here.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  return (
    <Badge 
      variant="secondary" 
      className={cn(
        "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
        className
      )}
    >
      <FlaskConical className="w-3 h-3 mr-1" />
      Demo Data
    </Badge>
  );
}
